export enum SupportedDeviceType {
  IOS_REAL_DEVICE = 'IOS_REAL_DEVICE',
  IOS_SIMULATOR = 'IOS_SIMULATOR',
}
